// eslint-disable-next-line import/prefer-default-export
export function formatCompanyLabel(company) {
  if (!company || !company.name) {
    return ''
  }

  return company.referent_name ? `${company.name} - ${company.referent_name}` : company.name
}
